import script from "./my-employee-p9.vue?vue&type=script&setup=true&lang=js"
export * from "./my-employee-p9.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__